import styled from 'styled-components';

import { colors, cssBreakpoints } from 'theme/theme';

export const CmsSocialSidebarContainer = styled.div<{
  $hasRecentJobs: boolean;
}>`
  display: none;
  margin-top: ${(props) => (props.$hasRecentJobs ? '-188px' : '-53px')};
  position: sticky;
  top: 400px;
  left: 90px;
  max-width: 200px;
  width: calc(100vw / 8);
  z-index: 3;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    display: block;
  }
`;

export const CmsSocialSidebarRecentJobsContainer = styled.div`
  border-bottom: 1px solid ${colors.elementGrey};
  padding-bottom: 25px;
`;

export const CmsSocialSidebarTooltipContainer = styled.div`
  margin-top: 25px;
  padding-left: 12px;
  display: flex;
  gap: 16px;
`;
